import { render } from "./app.vue?vue&type=template&id=5ef48958&ts=true"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"

import "./app.vue?vue&type=style&index=0&id=5ef48958&lang=scss"

import exportComponent from "/home/runner/work/hub_thunnus/hub_thunnus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ef48958"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ef48958', __exports__)) {
    console.log('reload')
    api.reload('5ef48958', __exports__)
  }
  
  module.hot.accept("./app.vue?vue&type=template&id=5ef48958&ts=true", () => {
    console.log('re-render')
    api.rerender('5ef48958', render)
  })

}


export default __exports__